import { mergeAttributes, Node } from '@tiptap/core';

const SpanNode = Node.create({
  name: 'span', // Node name

  inline: true, // Make it inline
  group: 'inline', // Part of inline content
  content: 'inline*', // Can contain other inline elements

  addAttributes() {
    return {
      class: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0];
  },
});

export default SpanNode;
